export const npsOgUri = `:apiUri/external-influencer/:reviewId/nps/og`;
export const popup = {
    width: 500,
    height: 500,
};
